import { createContext, useContext } from 'react';

export interface TranscodeContextValue {
  transcodingLayers: Map<string, number>;
  transcodeMovForLayer: (layerId: string, storageUri: string, name: string) => void;
}

const TranscodeContext = createContext<TranscodeContextValue>({
  transcodingLayers: new Map(),
  transcodeMovForLayer: () => {},
});

export const TranscodeProvider = TranscodeContext.Provider;
export const useTranscode = () => useContext(TranscodeContext);
